import React from 'react';
import WorkflowDashboard from './WorkflowDashboard';

/**
 * Home screen — the desktop workflow dashboard (workflow map, shortcut
 * panels and status sidebar). The old KPI/chart dashboard remains
 * available inside the Reports module.
 */
export default function Dashboard() {
  return <WorkflowDashboard />;
}
